import React from 'react';
import { Row, Col ,Container  } from 'react-bootstrap';
import ImageBox1 from '../../images/image-box-1.png'
import ImageBox2 from '../../images/image-box-2.png'
import ImageBox3 from "../../images/image-box-3.png"

const ImageBox = () => {
    return (
      <section id="image-box">
        <Container className="container">
          <Row>
            <Col md={4} className="text-center box-one img-box-wrapper">
              <img src={ImageBox1} alt="" className="img-fluid box-img" />
              <h1>Find The Right Rehab Center</h1>
              <p>
                Each person undergoing the addiction rehab journey requires
                specific attention. By using Rehab Find, you can be sure that
                you will be connected with the most suitable rehab centre.
              </p>
            </Col>
            <Col md={4} className="text-center img-box-wrapper">
              <img src={ImageBox2} alt="" className="img-fluid box-img" />
              <h1>The Perfect Rehab Center For YOU In The Next 5 Minutes</h1>
              <p>
                With Rehab Find’s advanced database, you can quickly sort
                thr/ough hundreds of specialists and treatments centers to find
                the perfect fit for your unique needs.
              </p>
            </Col>
            <Col md={4} className="text-center box-3 img-box-wrapper">
              <img src={ImageBox3} alt="" className="img-fluid box-img" />
              <h1>Fast Help for your needs</h1>
              <p>
                Addiction rehab is a daunting task and requires immediate
                attention. That is why Rehab Find has set up a system that will
                connect you to a specialist or treatment center, fast!
              </p>
            </Col>
          </Row>
        </Container>
      </section>
    )
}
 
export default ImageBox;